<template>
<!-- 打卡记录 -->
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>打卡记录</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <!-- 侧边树 -->
      <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="id"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          >
            <span class="span-ellipsis" slot-scope="{ node, data }" style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                <span :title="node.label" class="">{{data.name}}</span>
            </span>
          </el-tree>
        </el-card>
      </el-aside>
      <el-main style="height: 100%;padding:5px !important;  position: relative;width: 84%;">
        <el-card style="height:100% !important;" class="aside">
          <div class="search-section">
            <div style="display:flex;align-items:center">
              <div style="display:flex;align-items:center;margin-right:20px">
                <span style="margin-right:10px">日期:</span>
                <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <div style="display:flex;align-items:center">
                <el-input
                  v-model="search.personName"
                  placeholder="请输入姓名"
                  clearable
                >
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
              </div>
            </div>
          </div>
          <div class="build-table">
              <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100" center>
                <template slot-scope="scope">
                  <a style="padding-left:1vw;">{{ scope.row.index}}</a>
                </template>
              </el-table-column>
              <el-table-column label="班组">
                <template slot-scope="scope">
                  <span class="nowrap" style="width:100%;" :title="scope.row.teamName">{{ scope.row.teamName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="姓名" width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="考勤区域">
                <template slot-scope="scope">
                  <span>{{ scope.row.age }}</span>
                </template>
              </el-table-column>
              <el-table-column label="设备ID" width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.imei }}</span>
                </template>
              </el-table-column>
              <el-table-column label="现场照片">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.photoFile!=''"
                    :src="scope.row.photoFile"
                    style="width:70px;height:90px;"
                  />
                  <div
                    v-else
                    style="width:70px;height:90px;background: #ddd;display: flex;align-items: center;justify-content: center;"
                  >暂无图片</div>
                </template>
              </el-table-column>
              <el-table-column label="打卡时间" prop="createDate" width="200" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.date }}</span>
                </template>
              </el-table-column>
              <el-table-column label="进出方向">
                <template slot-scope="scope">
                  <p style="text-align: center;width:100%;">{{scope.row.typeName}}</p>
                  <!-- <span v-if="scope.row.status=='0'">进闸</span>
                  <span v-else-if="scope.row.status=='1'">出闸</span>-->
                </template>
              </el-table-column>
              <el-table-column label="体温" width="100">
                <template slot-scope="scope">
                  <span>{{ scope.row.temperature }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button size="mini" @click="personInfo(scope.$index, scope.row)">个人详情</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <div style="background:#fff">
             <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5,10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      listData: [], //表格数据
      search: {//查询
        personName: '',
        date: util.myTime.getCurTime(),
        projectId: ''
      },
      dataText: '数据加载中...',
      groupType: '',
      groupId:'',
      projectId:'',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      joinType:'2',
        dataTree: [],
       defaultProps: {
        children: 'list',
        label: 'name'
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
    }
  },

  mounted() {
    this.groupId = util.session.get('groupId')
    // console.log(this.addForm.scope)
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.$store.commit('getRoleId')
      this.groupId = this.$store.state.groupId
    }
    if (util.session.get('roleId') == '3') {
      this.joinType = '3'
      this.groupType = '3'
    } else if (this.$store.state.roleId == '4') {
      this.groupType = '1'
    } else if (this.$store.state.roleId == '5') {
      this.joinType = '2'
      this.groupType = '2'
    }
    this.getAll()
    // this.getData()
    this.getDict() //获取考勤
  },
  methods: {
    //获取所有项目
    getAll() {
      var that = this
      myHttp
        .getPageListPro({
          entId: this.groupId,
          levelType:2
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.entOfficeProjectMenu || []
            that.dataTree = list
            if (that.dataTree.length > 0) {
                for(var i=0;i<that.dataTree.length;i++){
                  if(list[i].list.length>0 && that.projectId==''){
                    that.projectId= list[i].list[0].id
                    that.currentNodekey = that.dataTree[i].list[0].id
                    that.expandedkeys.push(that.dataTree[i].list[0].id)
                    that.$nextTick(() => {
                      // treeBox 元素的ref   value 绑定的node-key
                      that.$refs.tree.setCurrentKey(that.currentNodekey)
                    })
                  }
                }
                that.getData()
            }else{
              that.dataText = '暂无数据'
            }
          }
        })
    },
    //点击树形结构
    handleNodeClick(data) {
      // console.log(data)
      if(data.list){
       return
      }else{
       this.projectId=data.id
       this.getData()
      }
      
    },
    //查询
    doFilter() {
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    rowClass() {
      //表头居中显示
      return 'text-align:center'
    },
    //
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'attend_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            that.attendType = resp.data.data.dictList
            // that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取类型
    filterSatus(str) {
      var list = this.attendType
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },

    // 获取数据
    getData() {
      var that = this
      this.listData = []
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      this.search.projectId = this.projectId
      myHttp.getAttendList(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].photoFile = list[i].photoFile && list[i].photoFile != '' ? base.httpCtx + list[i].photoFile : ''
              list[i].typeName = that.filterSatus(list[i].status)
            }
            that.listData = list
            that.totalItems = resp.data.data.pageInfo.total || 0
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    //查看
    handleEdit(row){
        util.session.set('url', row.applyPhotoUrl)
        util.session.set('proId', row.projectId)
        this.$router.push('/wageInfoEnt/'+row.applyFormId)
    },
    /**
     * 导出单个劳资
     */
    exportFun(row){
      var token = util.session.get('token')
      window.open(myHttp.exportTeamsApplyDetail+'?accessToken='+token+'&fromId='+row.applyFormId)
    },
  },
   
}
</script>
<style>
  @import '../../../assets/css/common.css';
  .el-tree-node__content{
      height: 30px;
  }
  .el-tree-node__label{
    font-size: inherit;
  }
  .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #ecf0f5;
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 10px 35px 10px 12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height:calc(100% - 12vh);
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-table th > .cell {
  text-align: center !important;
}
</style>